import axios from "axios"
import * as env from "../constants/env"
import { utils } from "../helpers"


/* List Logs */
export const list = ({ page = 1, search = "", tables = "", type = "", start = "", end = "" }) => {

    /* Prepare Params */
    const params = new URLSearchParams({ page: page || 1, timezone: utils.getTimezone() })

    if (search) params.set("search", search)
    if (tables) params.set("tables", tables)
    if (type) params.set("type", type)
    if (start) params.set("start", start)
    if (end) params.set("end", end)

    /* Send Request */
    const uri = `${env.startpoint}log/list?${params.toString()}`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }

    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}


/* Detail Of One Record (полное сообщение, повторы и соседние записи) */
export const detail = (id) => {

    const uri = `${env.startpoint}log/detail?id=${id}`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }

    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}


/* Filters Of The Section (столы и типы — строятся по самим логам) */
export const filters = () => {

    const uri = `${env.startpoint}log/filters`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }

    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}
